// @mui material components
import Grid from "@mui/material/Grid";
import { IonButton, IonContent, IonInput, IonItem, IonLabel, IonPage, IonSelect, option , IonLoading} from '@ionic/react';
import { degrees, PDFDocument, rgb, StandardFonts } from 'pdf-lib';
//import { ArrowDropDown } from "@mui/icons-material"; 
//import TableContainer from "@mui/material/TableContainer";
import {Typography} from '@mui/material';
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Header from "layouts/profile/components/Header";
import {ReactComponent as VerifyImage} from 'assets/images/verification.svg';
import Modal from '@mui/material/Modal';

// Soft UI Dashboard React components
import SuiBox from "components/SuiBox";

// Soft UI Dashboard React compone
import SuiTypography from "components/SuiTypography";
import SuiInput from "components/SuiInput";
import SuiDropdown from "components/SuiDropdown";
import SuiButton from "components/SuiButton";
//import Card from "@mui/material/Card";

// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Icon from "@mui/material/Icon";
import { FileUploader } from "react-drag-drop-files";
import axios from "axios";
import 'tui-image-editor/dist/tui-image-editor.css';
import FilerobotImageEditor, { TABS, TOOLS} from 'react-filerobot-image-editor';
import {PDFtoIMG} from 'react-pdf-to-image';
import { Auth } from "aws-amplify";
import Draggable from 'react-draggable';
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
//import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import InputAdornment from '@mui/material/InputAdornment';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import { useSnackbar } from "notistack";
//import { useNavigate } from "react-router-dom";


import {
  ProjectsUpcoming,
  ProjectsPast,
} from "layouts/event/components/Projects/indexAdminUpcoming";
//import {ProjectsPast} from "layouts/event/components/TableEvents/index";
import { useEffect, useState, createRef, useRef } from "react";
import Table from "layouts/event/components/Table";
import 'layouts/event/index.css'

function Event() {
  const [display, setDisplay] = useState(false);
  const [uploadCert, setUploadCert] = useState(false);
  const [eventName, setEventName] = useState("")
  const [eventId, seteventId] = useState("")

  const [Filename,setfilename] = useState()
  const [rows,setrows] = useState([])
  const [date1,setdate] = useState(new Date().getDate())
  const [name,setname] = useState("")
  const [reglink, setreglink] = useState("")
  const [x, setx] = useState(0)
  const [y, sety] = useState(0)
  // const [name, setName] = useState("test")
  const [cat, setcat] = useState("")
  const [R, setR] = useState(0)
  const [G, setG] = useState(0)
  const [B, setB] = useState(0)
  const [size, setSize] = useState(30)
  const [pdfinfo, setPdfInfo] = useState()
  const [pdf, setpdf] = useState()
  const [load,setload] = useState(false)
  const iframeRef = useRef(null);
  const [pdfDimensions, setPdfDimensions] = useState({ width: 600, height: 800 });
  const { enqueueSnackbar } = useSnackbar();
  const [loc,setloc] = useState("")
  const [tenant,settenant] = useState("")
  const [catError, setCatError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [events, setEvents] = useState([]);
  //const navigate = useNavigate();
  const [showBox, setShowBox] = useState(false);
  const [approvalStatus, setApprovalStatus ] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [serialX, setSerialX] = useState(150);
  const [serialY, setSerialY] = useState(100);
  const [currentSerialX, setCurrentSerialX] = useState(150);
  const [currentSerialY, setCurrentSerialY] = useState(100);
  const [serialSize, setSerialSize] = useState(12);
  const [ssm, setSSM]= useState("")
  const [customCat, setCustomCat] = useState('');
  const [subscriptionPlan, setSubPlan] = useState('');
  


  //modifiedSAAS
  useEffect(()=>{
    Auth.currentUserInfo().then(value=>{
      if(value.username == 'admin' ){   
        settenant("admin")
      }
      else{
          console.log(value.attributes["custom:company"]);
          settenant(value.attributes["custom:company"]);
          setApprovalStatus(value.attributes["custom:approvalStatus"]);
          setSSM(value.attributes["custom:ssm"]);
          setSubPlan("starter")
      }
    })
  },[])


  const dropdownOptions = [
    { value: 'Winner', label: 'Winner' },
    { value: 'Runner-Up', label: 'Runner-Up' },
    { value: 'Second Runner-Up', label: 'Second Runner-Up' },
    { value: 'Participant', label: 'Participant' },
    { value: 'Finalist', label: 'Finalist' },
    { value: 'Training', label: 'Training' },
    { value: 'Advisor', label: 'Advisor' },
  ];

  const categoryCodes = {
    winner: "A",
    "winner 1": "A",
    "runner-up": "B",
    "winner 2": "B",
    "second runner-up": "D",
    "winner 3": "D",
    participant: "E",
    finalist: "F",
    training: "G",
    advisor: "H"
  };

  let unlistedCategoryCounter = 1;
  const unlistedCategoryCodes = {};

  const getCategoryCode = (category) => {
    const normalizedCategory = category.toLowerCase().replace(/\s+/g, '-');
    if (categoryCodes[normalizedCategory]) {
      return categoryCodes[normalizedCategory];
    } else if (unlistedCategoryCodes[normalizedCategory]) {
      return unlistedCategoryCodes[normalizedCategory];
    } else {
      const newCode = `C${unlistedCategoryCounter}`;
      unlistedCategoryCodes[normalizedCategory] = newCode;
      unlistedCategoryCounter++;
      return newCode;
    }
  };

  const row = async () => {
    console.log(tenant);
    console.log(eventId);
    try {
      const response = await axios.post("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/getCert2", {
        event: eventId,
        tenant: tenant
      });
      const rows1 = response.data.map((certs) => ({
        Name: certs.filename,
        Category: `${certs.Category} - ${getCategoryCode(certs.Category)}`,
        Edit: <SuiButton variant="outlined" color="info" size="small" onClick={() => setfilename(certs.id)}>Edit</SuiButton>,
        Delete: <SuiButton variant="outlined" color="info" size="small" onClick={() => deletecert(certs.id)}>Delete</SuiButton>
      }));
      setrows(rows1);
    } catch (error) {
      console.error("Error fetching certificates:", error);
    }
  };

  useEffect(()=>{
    row()
    fetchEventList();
  },[])

  const fetchEventList = async () => {
    try {
      const response = await axios.get("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/getEvents");
      const eventList = response.data
        .filter(event => event.tenant === tenant) // Filter events by tenant
        .map(event => ({
          Event: event.name,
          Date: event.date,
          Location: event.location,
          Actions: (
            <>
              <SuiButton variant="text" color="info" size="small" onClick={() => handleView(event.id)}>
                <Icon>visibility</Icon>
              </SuiButton>
              {/* <SuiButton variant="text" color="success" size="small" onClick={() => handleEdit(event.id,event.name)}>
                <Icon>edit</Icon>
              </SuiButton> */}
            </>
          ),
        }));

      setEvents(eventList);
    } catch (error) {
      console.error('Error fetching events:', error);
    }
  };

  const handleView = (eventId) => {
    console.log(`View event ${eventId}`);
    // Implement view event functionality here
  };

  // const handleEdit = (eventId,eventName) => {
  //   console.log(`Edit event ${eventId} - ${eventName}`);
  //   navigate(`/edit-event/${eventId}`, { state: { eventName } });
    
  // };

  useEffect(()=>{
    if (Filename) {
      modifyPdf(Filename, x, y , R, G, B,);
    }
  },[Filename,x, y, R, G, B, size])

  const certColumns = [
    { name: "Name", align: "left" },
    { name: "Category", align: "left" },
    // { name: "Edit", align: "center" },
    { name: "Delete", align: "center" },
  ];

  const eventColumns = [
    { name: "Event", align: "left" },
    { name: "Date", align: "left" },
    { name: "Location", align: "center" },
    { name: "Actions", align: "center" },
  ];

  async function deletecert(certname){
    await axios.post("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/removeCert",{id:certname}).then(value=>{
      row();
    })
  }

  //modifiedSAAS
  async function addevent(){

    if(approvalStatus==="3"){
      const response = await axios.get("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/getEvents");
      
      const filteredEvents = response.data.filter(event => event.ssm === ssm);
      console.log(filteredEvents)
      let eventCode = generateEventCode(filteredEvents);

        // Function to generate event code
        function generateEventCode(events) {
          // Extract existing codes
          const existingCodes = events.map(event => event.code);
          
          // Sort existing codes
          existingCodes.sort((a, b) => {
            const [aLetter, aNumber] = [a.charCodeAt(0), parseInt(a.slice(1))];
            const [bLetter, bNumber] = [b.charCodeAt(0), parseInt(b.slice(1))];
            if (aLetter === bLetter) {
              return aNumber - bNumber;
            }
            return aLetter - bLetter;
          });

          // Generate next code
          if (existingCodes.length === 0) {
            return "A01";
          }
          
          const lastCode = existingCodes[existingCodes.length - 1];
          let [letter, number] = [lastCode.charCodeAt(0), parseInt(lastCode.slice(1))];

          if (number < 99) {
            number += 1;
          } else {
            letter += 1;
            number = 1;
          }

          return String.fromCharCode(letter) + number.toString().padStart(2, '0');
        }
        console.log(eventCode)

        try {
          // Simple validation checks
         if (!name) {
           throw new Error("Event name is required.");
         }
         
         if (!date1) {
           throw new Error("Event date is required.");
         }
         // Additional date format validation can be added here
         // Example: Use regex or a date parsing library to validate the date format  
         if (!loc) {
           throw new Error("Event location is required.");
         }
 
         if (!reglink) {
           throw new Error("Registration link is required.");
         }
 
         // Simple URL validation
         const urlPattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
           '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name
           '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
           '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
           '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
           '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
         if (!urlPattern.test(reglink)) {
           throw new Error("Invalid registration link URL.");
         }
 
         if (!tenant) {
           throw new Error("Tenant is required.");
         }
 
         if (!ssm) {
           throw new Error("SSM is required.");
         }

         
          // Determine the maximum allowed events based on the subscription plan
          const maxEvents = {
            starter: 3,
            basic: 10,
            pro: 50,
          }[subscriptionPlan] || 0; // Default to 0 if plan is unknown

          // Check if the user has reached their event creation limit
          if (filteredEvents.length >= maxEvents) {
            throw new Error(`You have reached the limit of ${maxEvents} events for your ${subscriptionPlan} plan.`);
          }
       
         const response = await axios.post("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/AddEvents", {
           name: name,
           date: date1,
           location: loc,
           registrationlink: reglink,
           tenant: tenant,
           ssm: ssm,
           eventcode:eventCode
         });
         enqueueSnackbar("Event Added", { variant: 'success' });
         // Update your UI state here to save the event name
         console.log(response.data);
         seteventId(response.data)
         // console.log(eventName);
       } catch (error) {
         console.error("Error adding event:", error);
         enqueueSnackbar(`Failed to add event: ${error.message}`, { variant: 'error' });
         // Handle error gracefully, e.g., show a toast message
       }
      
    }else{
      enqueueSnackbar("Please complete the verification", { variant: 'warning' });
    }
}

  async function createcertdetails(){
    if (!cat) {
      setCatError(true);
    } else {
      setCatError(false);
      try {

        const categoryToSend = cat === 'custom' ? customCat : cat;
        console.log(name);
        await axios.get(`https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/AddCert?filename=${Filename}&cat=${categoryToSend}&x=${x}&y=${y}&fontsize=${size}&eventname=${name}&eventId=${eventId}&serialX=${serialX}&serialY=${serialY}`);
        enqueueSnackbar("Certificate Added", { variant: 'success' });
        row();
        setPdfInfo(null);
        setcat("");
        setCustomCat("");
        setSize(0);
        setR(0);
        setG(0);
        setB(0);
        setSerialX(150);
        setSerialY(100);
        setShowBox(!showBox);

        
      } catch (error) {
        console.error(error);
        enqueueSnackbar("Failed to add certificate", { variant: 'error' });
      }
    }
}


const handleStop = (e, data) => {
  setx(data.x);
  sety(data.y);
  console.log(`Text field moved to x: ${data.x}, y: ${data.y}`);
};

// useEffect(() => {
//   modifyPdf(Filename)
// }, [x, y, R, G, B, size])

async function modifyPdf(file) {
  try {
    const existingPdfBytes = await fetch(`https://certificatesys.s3.ap-southeast-1.amazonaws.com/${tenant}/${eventId}/${file}`).then(res => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const pages = pdfDoc.getPages();
    const firstPage = pages[0];
    const { width, height } = firstPage.getSize();

    // Calculate the width of the text
  const textWidth = helveticaFont.widthOfTextAtSize("[Sample Text]", parseInt(size));

  // Calculate the x-coordinate to center the text
  const centerX = (width - textWidth) / 2;


    // firstPage.drawText("[Sample Text]", {
    //   x: centerX-9,
    //   y: height - parseInt(y) + 23,
    //   size: parseInt(size),
    //   font: helveticaFont,
    //   color: rgb(parseFloat(R), parseFloat(G), parseFloat(B)),
    // });

    const pdfBytes = await pdfDoc.save();
    const bytes = new Uint8Array(pdfBytes);
    const blob = new Blob([bytes], { type: "application/pdf" });
    const docUrl = URL.createObjectURL(blob);
    setPdfInfo(docUrl);
    setPdfDimensions({ width, height });
  } catch (error) {
    console.error("Error modifying PDF:", error);
  }
}

  async function uploadfile(file) {
      
      setload(true)

      await  axios.get(`https://hlsw9m3hud.execute-api.ap-southeast-1.amazonaws.com/default/uploadfile?filename=${file.name}&bucket=certificatesys&event=${eventId}&tenant=${tenant}&typeupload=file`).then(async (value)=>{
              //Create the FormData
              //Send the file to File-system
        console.log("Sending file to S3...");
        await axios.put(value.data, file, {    
          headers: {
              'Content-Type': 'application/pdf',
          } 
        }).then( value => {
          setload(false)
          modifyPdf(file.name)
          setx(0)
          sety(0)
        }).catch (error=> {
          console.log(error)
        })  
  }).catch(error =>{
    console.log(error)
  })       
}
  const handleChange = async (file) => {
    setfilename(file.name)
    uploadfile(file);

    const url = URL.createObjectURL(file);
    const pdf = await pdfjsLib.getDocument(url).promise;
    const page = await pdf.getPage(1);
    const viewport = page.getViewport({ scale: 1 });

    setPdfDimensions({ width: viewport.width, height: viewport.height });
  };


  const toggleBoxVisibility = () => {
    setShowBox(!showBox);
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSelectChange = (e) => {
    const value = e.target.value;
    setcat(value);
    if (value === 'custom') {
      setCustomCat(''); // Reset custom category input if 'custom' is selected
    }
    setCatError(false);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setCustomCat(value);
    setcat('custom');
  };


    return (
      <DashboardLayout>
        <DashboardNavbar />
        {/* <IonLoading isOpen={load} message={"Hang on, opening Certificate Editor"}/> */}
        <SuiBox mt={1} mb={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={3}>
                <SuiBox 
                    p={2} 
                    bgColor={"white"}                   
                    borderRadius="xl" 
                    display="flex"
                    flexDirection="column"  
                    >
                <SuiTypography component="label" fontWeight="bold">
                          New Event Details
                        </SuiTypography>
                        <SuiBox mb={2}>
                          <SuiBox mb={1} ml={0.5}>
                            <SuiTypography component="label" variant="caption" fontWeight="bold">
                              Event Name
                            </SuiTypography>
                          </SuiBox>
                          <SuiInput type="text" placeholder="Name" onChange={(e)=>{setname(e.target.value)}}/>
  
                          <SuiBox mb={1} ml={0.5}>
                            <SuiTypography component="label" variant="caption" fontWeight="bold">
                              Event Location
                            </SuiTypography>
                          </SuiBox>
                          <SuiInput type="text" placeholder="Location" onChange={(e)=>{setloc(e.target.value)}}/>
  
                          <SuiBox mb={1} ml={0.5}>
                            <SuiTypography component="label" variant="caption" fontWeight="bold">
                              Event Website
                            </SuiTypography>
                          </SuiBox>
                          <SuiInput type="text" placeholder="Link" onChange={(e)=>{setreglink(e.target.value)}}/>
  
                          <SuiBox mb={1} ml={0.5}>
                            <SuiTypography component="label" variant="caption" fontWeight="bold">
                              Event Date
                            </SuiTypography>
                          </SuiBox>
                          <SuiInput type="date" placeholder="Date" onChange={(e)=>{setdate(e.target.value)}} />
                        </SuiBox>
                        {/* <SuiBox mb={1}>
                        <SuiTypography component="label" variant="caption" fontWeight="bold">
                              Certificate Template
                        </SuiTypography>                         
                        <FileUploader className="file-uploader" handleChange={handleChange} types={['pdf']} />
                        
                        </SuiBox> */}
                        <SuiBox mt={4} mb={1} align="center">
                          <SuiButton
                            color="dark"
                            variant="gradient"
                            //onClick={() => setUploadCert(!uploadCert)}
                            onClick={() => addevent()}
                          >
                            Add Event Certificate
                          </SuiButton>
                        </SuiBox>
                </SuiBox>    
              </Grid>
            <Grid item xs={12} lg={9} sx={{ display: "flex", flexDirection: "column" }}>
            <SuiBox
              p={2}
              bgColor={"white"}
              borderRadius="xl"
              sx={{ flex: 1, display: "flex", flexDirection: "column" }}
            >
              <SuiBox>
              <SuiTypography component="label" fontWeight="bold">
                          Certificate Lists
                        </SuiTypography>    
                  <SuiButton onClick={row} style={{float:"right",marginRight: "10px" }} variant="gradient" color="dark">                    
                          <Icon sx={{ fontWeight: "bold" }}>refresh</Icon>
                  </SuiButton>
                  <SuiButton onClick={toggleBoxVisibility} style={{float:"right",marginRight: "10px"}} variant="outlined" color="info">                    
                          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                  </SuiButton>
              </SuiBox>   
                          {/* <Table
                            columns={columns} 
                            rows={rows} /> */}
                    {rows.length === 0 ? ( // Conditionally render the message when rows array is empty
                      <SuiBox>
                        <SuiTypography variant="h5" color="secondary" textAlign="center" mt={2}>
                        There are no certificates for this event yet.
                        </SuiTypography>
                      </SuiBox>   
                      ) : (
                        <SuiBox
                          sx={{
                            "& .MuiTable-root": {
                              boxShadow: "none",
                              backgroundColor: "#fff", // Example background color for the table
                            },
                            "& .MuiTableCell-root": {
                              padding: "16px", // Example padding for the table cells
                              fontSize: "14px", // Example font size for the table cells
                            },
                            "& .MuiTableRow-root": {
                              "&:hover": {
                                backgroundColor: "#fff", // Example hover effect for table rows
                              },
                            },
                            "& .MuiTableHead-root": {
                              "& .MuiTableCell-root": {
                                fontWeight: "bold", // Example font weight for the table header cells
                                backgroundColor: "#fff", // Example background color for the table header cells
                              },
                            },
                          }}
                        >
                          <Table columns={certColumns} rows={rows} />
                        </SuiBox>
                      )}
                </SuiBox> 
              </Grid>
            </Grid>
        </SuiBox>
        {showBox && (
          <SuiBox mt={3} mb={3} bgColor={"white"} borderRadius="xl">
            <Grid container>
              <Grid item xs={12} lg={3}>
                <SuiBox p={2} pr={4}>
                  <SuiBox mt={0} mb={0}>
                    <h4>Certificate Details</h4>
                  </SuiBox>
                  <SuiTypography component="label" variant="caption" fontWeight="bold">
                    Certificate Template
                  </SuiTypography>
                  <FileUploader className="file-uploader" handleChange={handleChange} types={['pdf']} />
                  <SuiTypography component="label" variant="caption" fontWeight="bold">
                    Certificate Category
                  </SuiTypography>
                  <SuiBox>
                  <select
                  className="dropdownInputField"
                  value={cat}
                  onChange={handleSelectChange}
                  required
                  >
                  {dropdownOptions.map((category, index) => (
                    <option key={index} value={category.value}>
                      {category.label}
                    </option>
                  ))}
                    {subscriptionPlan === "pro" && (
                      <option value="custom">Custom Category</option>
                    )}
                  </select>
                
                {cat === 'custom' && (
                  <SuiBox pt={1}>
                    <SuiInput
                      type="text"
                      className="customCategoryInput"
                      value={customCat}
                      onChange={handleInputChange}
                      placeholder="Enter custom category"
                      required
                    />
                  </SuiBox>    
                )}  
                {/* {catError && <span className="error-text">Please select a category</span>} */}
                  </SuiBox>
  {/*                 
                  <SuiDropdown
                    options={[
                      { value: 'winner 1', label: 'Winner' },
                      { value: 'winner 2', label: 'Runner-Up' },
                      { value: 'winner 3', label: 'Second Runner-Up' },
                      { value: 'participant', label: 'Participant' },
                      { value: 'finalist', label: 'Finalist' },
                      { value: 'training', label: 'Training' },
                      { value: 'advisor', label: 'Advisor' },
                    ]}
                    value={cat}
                    onChange={(e) => setcat(e.target.value)}
                    size="medium"
                    error={catError}
                    success={false}
                    disabled={false}
                  /> */}
                  <SuiTypography component="label" variant="caption" fontWeight="bold">
                    Font Size:
                  </SuiTypography>
                  <SuiInput type="number" placeholder="0" onChange={(e) => setSize(e.target.value)} />
                  {/* <SuiTypography component="label" variant="caption" fontWeight="bold">
                    Font Color:
                  </SuiTypography>
                  <SuiInput
                    type="color"
                    onChange={(e) => {
                      const color = e.target.value.match(/\w\w/g).map(x => parseInt(x, 16) / 255);
                      setR(color[0]);
                      setG(color[1]);
                      setB(color[2]);
                    }}
                  /> */}
                  <SuiBox mt={3}>
                    <SuiButton variant="gradient" color="dark" onClick={() => { createcertdetails() }}>Add Certificate</SuiButton>
                  </SuiBox>
                </SuiBox>
              </Grid>
              <Grid item xs={12} lg={9}>
                <SuiBox p={2} pr={4}>
                  {pdfinfo ? (
                    <SuiBox sx={{ position: 'relative', height: '100%' }}>
                      <iframe
                        src={`${pdfinfo}#toolbar=0&navpanes=0`}
                        ref={iframeRef}
                        style={{
                          width: `${pdfDimensions.width}px`,
                          height: `${pdfDimensions.height}px`,
                          border: '1px solid #ccc',
                          borderRadius: '8px',
                          overflow: "auto"
                        }}
                      />
                      <Draggable
                        position={{ x, y }}
                        bounds="parent"
                        onStop={handleStop}
                      >
                        <SuiBox
                          sx={{
                            position: 'absolute',
                            padding: `${size / 4}px`,
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            backgroundColor: 'white',
                            cursor: 'move',
                            userSelect: 'none',
                            top: 0,
                            left: 0,
                            transform: `translate(${x}px, ${y}px)`,
                            fontSize: `${size}px`
                          }}
                        >
                          <SuiTypography color={'rgba(0, 0, 0, 0.0)'} style={{ fontSize: `${size}px` }}>
                            [Sample Name]
                          </SuiTypography>
                        </SuiBox>
                      </Draggable>
                      <Draggable
                    position={{ x: serialX, y: serialY }}
                    bounds="parent"
                    onStop={(e, data) => { setSerialX(data.x); setSerialY(data.y); }}
                  >
                    <SuiBox
                      sx={{
                        position: 'absolute',
                        padding: `${serialSize / 4}px`,
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        backgroundColor: 'white',
                        cursor: 'move',
                        userSelect: 'none',
                        top: 0,
                        left: 0,
                        transform: `translate(${serialX}px, ${serialY}px)`,
                        fontSize: `${serialSize}px`
                      }}
                    >
                      <SuiTypography color={'rgba(0, 0, 0, 0.0)'} style={{ fontSize: `${serialSize}px` }}>
                        [Serial Number]
                      </SuiTypography>
                    </SuiBox>
                  </Draggable>
                    </SuiBox>
                  ) : (
                    <SuiTypography variant="h5" color="textSecondary" textAlign="center" mt={2}>
                      No PDF uploaded yet.
                    </SuiTypography>
                  )}
                </SuiBox>
              </Grid>
            </Grid>
          </SuiBox>
        )} 
        <SuiBox mt={0} mb={3}>{ProjectsPast("Past Events")}</SuiBox>
        {/* <Card>
        <SuiBox p={3}>
              <SuiTypography component="label" fontWeight="bold">
                          Past Event
                        </SuiTypography>
                  <SuiButton onClick={fetchEventList} style={{float:"right"}} variant="gradient" color="dark">                    
                          <Icon sx={{ fontWeight: "bold" }}>refresh</Icon>
                          </SuiButton>
              </SuiBox>   
                    {events.length === 0 ? ( // Conditionally render the message when rows array is empty
                      <SuiBox p={10}>
                        <SuiTypography variant="h5" color="secondary" textAlign="center" mt={2}>
                        There are no past event yet.
                        </SuiTypography>
                      </SuiBox>   
                      ) : (
                        <SuiBox px={2}>
                          <Table columns={eventColumns} rows={events} />
                        </SuiBox>
                      )}
        </Card> */}
        <SuiBox mt={4}> 
        </SuiBox>
        {/* <Footer /> */}
      </DashboardLayout>
    );
}

export default Event;
